<div class="survey-attendee-table">
  <filter-list-container
    [DataTableSchema]="tableSchema"
    [filterSchema]="filterSchema"
    [forSection]="true"
    [elementId]="elementId">
  </filter-list-container>
</div>
